import { NgModule } from 'ng-metadata/core';
import {PrmResourceTypeFilterBar} from './resourceTypeFilterBar.directive';
import {ResourceTypeFilterBarService} from './resourceTypeFilterBar.service';

@NgModule({
    declarations: [
        PrmResourceTypeFilterBar
    ],
    providers: [
        ResourceTypeFilterBarService  
    ],
    imports:[]
})
export class ResourceTypeFilterBarModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceTypeFilterBar/resourceTypeFilterBar.module.ts